import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_user/messages/$conversationId/")({
  staticData: { title: "Conversation" },
  head: () => ({
    title: "Coach Conversation | Dream Coach Match",
    meta: [
      {
        name: "description",
        content:
          "Continue your coaching conversation and get personalized guidance.",
      },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});
